
























import Vue, { PropOptions } from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import * as models from '@/class/models/views/graph';

interface Data {
  titles: string[];
  classList: string[];
  style: any;
  bodies: any[];
  footers: string[];
  labelColors: any[];
}
interface Props {
  tooltip: models.ITooltip;
  positionFixed: boolean;
}

export const tooltipOption = {
  enabled: false,
  callbacks: {},
  intersect: true,
  mode: 'nearest',
  titleFontFamily: '\'Noto Sans JP\', sans-serif',
  bodyFontFamily: '\'Noto Sans JP\', sans-serif',
  footerFontFamily: '\'Noto Sans JP\', sans-serif',
  bodyFontStyle: 'bold',
  titleMarginBottom: 7,
  footerMarginTop: 10,
  bodySpacing: 7,
  footerSpacing: 6,
  xPadding: 12,
  yPadding: 12,
};

export default Vue.extend({
  name: 'GraphTooltip',
  data() {
    return {
      titles: [],
      classList: [],
      style: {},
      bodies: [],
      footers: [],
      labelColors: [],
    };
  },
  props: {
    tooltip: {} as PropOptions<models.ITooltip>,
    positionFixed: false,
  },
  watch: {
    tooltip: {
      deep: true,
      async handler(param: models.ITooltip) {
        const tooltipModel = param.tooltipModel;
        const position = param.position;
        this.style = {
          top: position.top + tooltipModel.y * param.ratio + 'px',
          left: position.left + tooltipModel.x * param.ratio + 'px',
          width: tooltipModel.width + 'px',
          height: tooltipModel.height + 'px',
          transform: `scale(${param.ratio})`,
          opacity: tooltipModel.opacity,
        };
        if (tooltipModel.body) {
          this.titles = tooltipModel.title;
          this.bodies = tooltipModel.body;
          this.footers = tooltipModel.footer;
          this.labelColors = tooltipModel.labelColors;
          this.classList = [ tooltipModel.xAlign, tooltipModel.yAlign ];
        }
      },
    },
  },
  /* ツールチップの表示処理はBasicGadgetで実装 */
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, {}, {}, Props>);
